import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { api } from "@/lib/apiClient";
import { PickCard } from "@/components/routine/TodayForYou";

const SITUATIONS = [
  ["date", "A date"], ["new-people", "Meeting someone new"], ["big-moment", "A big moment"],
  ["knock", "I've had a knock"], ["overthinking", "I'm overthinking"], ["feel-good", "I just want to feel good"],
];

export default function WalkingInto({ onOpen }) {
  const [res, setRes] = useState(null);
  const [sel, setSel] = useState(null);
  const pick = async (id) => {
    setSel(id);
    try { const { data } = await api.post("/routine/walking-into", { situation: id }); setRes(data); } catch { setRes(null); }
  };
  return (
    <section className="mb-12" data-testid="routine-walking-into">
      <h2 className="text-xs uppercase tracking-[0.22em] text-foreground/90 mb-4">What are you walking into?</h2>
      <div className="flex flex-wrap gap-2 mb-4">
        {SITUATIONS.map(([id, l]) => (
          <button key={id} onClick={() => pick(id)} data-testid={`walking-${id}`}
            className={`px-4 py-2 rounded-full text-sm border transition-colors duration-300 ${sel === id ? "bg-foreground text-background border-foreground" : "border-border text-foreground/80 hover:border-primary/50"}`}>{l}</button>
        ))}
      </div>
      <AnimatePresence mode="wait">
        {res && (
          <motion.div key={sel} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} data-testid="walking-result">
            <p className="font-serif text-lg italic text-foreground/85 mb-3">{res.line}</p>
            <PickCard p={res.action} onOpen={onOpen} testId="walking-action" />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
